function InputSelectTablaAfec({ value, setValue, label }) {

    return (
        <div className="form-group">
            <label>{label}</label>
            <select
                className="input"
                value={value || ""}
                onChange={(e) => setValue(e.target.value)}
            >
                <option value="" disabled>
                    Seleccione una opción
                </option>
                <option value="tecnicos">Técnicos</option>
                <option value="solicitudes">Solicitudes</option>
                <option value="bienes">Bienes</option>
                <option value="bajas">Bajas</option>
                <option value="usuarios">Usuarios</option>
                <option value="switches">Switches</option>
                <option value="patch_panels">Patch Panels</option>
                <option value="ips">Ips</option>
            </select>
        </div>
    );
}

export default InputSelectTablaAfec;